export const METADATA_FILL_METHOD = {
  USER_SET: 'User Set',
  AI_GENERATED: 'AI Generated',
} as const;

export type MetadataFillMethod =
  (typeof METADATA_FILL_METHOD)[keyof typeof METADATA_FILL_METHOD];
